import sentenceCapitalize from 'shared/utils/formatting/sentenceCapitalize';

function formatKeyActionName(keyActionName) {
	return sentenceCapitalize(keyActionName.replaceAll('_', ' '));
}

export default formatKeyActionName;
